/**
 * Единая точка настройки API бэкенда (прод / тест).
 *
 * Задаётся через REACT_APP_API_URL в .env.development / .env.production (корень проекта).
 * См. .env.example
 */

// const DEFAULT_API_URL = 'https://api.registratorspb.ru';
const DEFAULT_API_URL = 'https://test.registratorspb.ru/api';

function normalizeBaseUrl(raw) {
  const s = (raw || '').trim().replace(/\/+$/, '');
  return s || DEFAULT_API_URL;
}

/** Базовый URL API без завершающего слэша */
export const API_BASE_URL = normalizeBaseUrl(process.env.REACT_APP_API_URL);

/** @deprecated Используйте API_BASE_URL; оставлено для совместимости */
export const url = API_BASE_URL;

/**
 * Socket.IO слушает корень хоста, REST часто под /api (тест).
 * https://test…/api → https://test…
 */
export function resolveSocketUrl(apiBase = API_BASE_URL) {
  const base = (apiBase || '').replace(/\/+$/, '');
  if (base.endsWith('/api')) {
    return base.slice(0, -4);
  }
  return base;
}

export const SOCKET_URL = resolveSocketUrl(API_BASE_URL);

/** Полный URL эндпоинта: apiUrl('/login') → https://api…/login */
export function apiUrl(path = '') {
  if (!path) return API_BASE_URL;
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${p}`;
}

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info('[API]', API_BASE_URL, '[Socket]', SOCKET_URL);
}
